import { ReactNode } from 'react';
import { MenuItem } from '@szhsin/react-menu';

import { Checked, Unchecked } from '../shared';

export const FilterCheckboxItem = ({
  checked,
  onChange,
  children,
}: {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  children: ReactNode;
}) => {
  return (
    <MenuItem
      type="checkbox"
      checked={checked}
      onClick={(e) => {
        onChange?.(!checked);
        e.keepOpen = true;
      }}
    >
      {checked ? Checked : Unchecked}
      {children}
    </MenuItem>
  );
};
